import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { AiSearchAutoEvalView } from "./AiSearchAutoEvalView";
import { AiSearchAutoEvalViewStore } from "../../store/AiSearchAutoEvalViewStore";
import { useStore } from "../../../../hooks";

export const AiSearchAutoEvalViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/aiSearchAutoEval/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new AiSearchAutoEvalViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <AiSearchAutoEvalView aiSearchAutoEvalViewStore={store} />
      </PageLayout>
    </div>
  );
});
